import { render, staticRenderFns } from "./DashboardClient.vue?vue&type=template&id=46198544&"
import script from "./DashboardClient.vue?vue&type=script&lang=js&"
export * from "./DashboardClient.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClient.vue?vue&type=style&index=0&id=46198544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports